<template>
    <div class="carrot-layer-bg">
        <JobRotationApplicantViewPopup :idx="pop.idx" v-if="pop.isShowApplicant" @close="pop.hideApplicant"></JobRotationApplicantViewPopup>

        <div class="carrot-layer w-500px">
            <div>
                <p class="title">신청자 리스트</p> 
                <span class="btn-close" @click="bbs.onClose()"><i class="fas fa-times"></i></span>
            </div>
            <div class="mt-10 tbl-light">
                <table class="tbl-light-list">
                    <colgroup>
                        <col width="80">
                        <col width="*">
                        <col width="150">
                        <col width="150">
                        <col width="150">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>본부</th>
                            <th>팀</th>
                            <th>이름</th>
                            <th>신청서</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(irow, i) in bbs.list" :key="i">
                            <td>{{ irow.num }}</td>
                            <td>{{ irow.office_name }}</td>
                            <td>{{ irow.team_name }}</td>
                            <td>{{ irow.ename }}({{ irow.kname }})</td>
                            <td><span class="btn-view" @click="pop.showApplicant(irow.idx)">VIEW</span></td>
                        </tr>
                        <tr v-if="bbs.total==0">
                            <td colspan="5">신청자가 없습니다.</td>
                        </tr>
                        <!-- <tr>
                            <td>00</td>
                            <td>경영기획실</td>
                            <td></td>
                            <td>Min K(김민정)</td>
                            <td><span class="btn-view">VIEW</span></td>
                        </tr> -->
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, reactive } from 'vue'
import { useToast } from 'vue-toastification';
import axios from '@/plugins/axios.js'
import JobRotationApplicantViewPopup from '@/components/popup/myPIMS/JobRotationApplicantViewPopup.vue'

export default {
    name: 'JobRotationApplicantListPopup',
    components: {
        JobRotationApplicantViewPopup
    },
    props: {
        idx: {
            type: [Number, String],
            default: 0,
        }
    },
    setup(props, {emit}) {
        const toast = useToast()

        const pop = reactive({
            idx : 0,
            isShowApplicant : false,

            showApplicant : (idx) => {
                pop.idx = idx;
                pop.isShowApplicant = true;
            },

            hideApplicant : () => {
                pop.idx = 0;
                pop.isShowApplicant = false;

                bbs.doSearch();
            },
        });

        const bbs = reactive({
            idx  : 0,
            list : [], total : 0,

            doSearch : () => {
                let params = {
                    idx : bbs.idx,
                };

                axios.get('/rest/mypims/getJRApplicantList', { params : params }).then((res) => {
                    if( res.data.err == 0 ){
                        bbs.list  = res.data.list;
                        bbs.total = res.data.total;
                    } else {
                        if(res.data.err_msg) toast.error(res.data.err_msg);
                    }
                });
            },

            onClose: () => {
                emit('close');
            }
        });

        onMounted(() => {
            // Mounted
            bbs.idx    = props.idx;

            bbs.doSearch();
        });

        return {pop, bbs};
    }
}
</script>
<style lang="scss" scoped>
</style>